import { NgModule } from '@angular/core';
import { ErpTravelManagementValueService } from './service/travelmanagementvalue.service';
import { ErpTravelManagementCommonService } from './service/travelmanagementcommon.service';

@NgModule( {
    imports: [
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        ErpTravelManagementValueService,
        ErpTravelManagementCommonService,
    ],
} )

export class TravelManagementCoreModule {
}
